<template>
	<div class="omapi-card__flex omapi-dash__notifications">
		<common-card
			class="omapi-dash__notifications"
			type="minimize"
			footerClass="dismiss-all-notices"
		>
			<template v-slot:title>{{ title }}</template>
			<div v-if="hasNotifications || isLoading" class="om-notifications">
				<transition name="notifications-slide">
					<notifications-list
						:notificationsToShow="subset"
						keyPrefix="widget-"
						@remove="remove"
					/>
				</transition>
			</div>
			<p v-else>
				No notifications at this time.
			</p>

			<template v-slot:footer>
				<a
					v-if="hasNotifications && leftover"
					href="#"
					class="omapi-link-arrow-after"
					@click.prevent="toggleNotifications"
				>You have {{ leftover }} more notifications</a>
				<a
					v-if="hasNotifications"
					href="#"
					@click.stop.prevent="dismissAll"
				>Dismiss All</a>
			</template>
		</common-card>
	</div>
</template>

<script lang="js">
import { notifications } from '@/notifications/mixins/notifications'

export default  {
	mixins   : [ notifications ],
	computed : {
		subset () {
			const notifications = []

			try {
				this.notifications.forEach((notif) => {
					notifications.push(notif)
					if (2 < notifications.length) {
						throw new Error()
					}
				})
			} catch (e) {}

			return notifications
		},
		showthem () {
			return this.hasNotifications || this.isLoading
		},
		leftover () {
			return this.total - this.subset.length
		},
	},
	methods : {
		toggleNotifications (event) {
			event.stopPropagation()
			// this changes the scrolling behavior to "smooth"
			window.scrollTo({ top: 0, behavior: 'smooth' })
			setTimeout(() => this.$bus.$emit('notificationsToggle'), 500)
		},
	},
}
</script>
<style lang="scss" scoped>
	.omapi-dash__notifications {
		overflow: hidden;
	}
</style>
